import { Modal } from "antd";
import moment from "moment";
import React from "react";
import {useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import { getLightNovelById, getMangaById, getWebtoonById } from "./endpoint";
import pageReloadOptions from "./enums";

export default function AuthorModal({
  openAuthorModel,
  setOpenAuthorModel,
  authorSummaryData,
  currentMangaId,
  currentWebtoonId,
  currentLightNovelId,
  isPageReload,
  isLinkFunctionalityActive
}) {

  const navigate = useNavigate()

  const handleRedirectToViewMangaPage = async (manga_id) => {
    try {
      const res = await getMangaById({manga_id});
      let url = `/admin/manga/view-manga/${manga_id}?redirect=1`

      if(isPageReload === pageReloadOptions.MANGA){
        setOpenAuthorModel(false);
        localStorage.setItem('is_same_manga_view_page',true);
        url = `/admin/manga/view-manga/${manga_id}`
      }

      navigate(url,{
        state: { row: res?.data },
      });
    } catch (error) {
      toast.error(`${error.message}`);
    }
  }

  const handleRedirectToViewLightNovelPage = async (lightNovel_id) => {
    try {
      const res = await getLightNovelById({lightNovel_id});
      let url = `/admin/lightNovel/view-Light-Novel/${lightNovel_id}?redirect=1`

      if(isPageReload === pageReloadOptions.LIGHT_NOVEL){
        setOpenAuthorModel(false);
        localStorage.setItem('is_same_light_novel_view_page',true);
        url = `/admin/lightNovel/view-Light-Novel/${lightNovel_id}`
      }

      navigate(url, {
        state: { row: res?.data },
      });
    } catch (error) {
      toast.error(`${error.message}`);
    }
  }


  const handleRedirectToViewWebtoonPage = async (webtoon_id) => {
    try {
      const res = await getWebtoonById({webtoon_id});
      let url = `/admin/webtoon/view-webtoon/${webtoon_id}?redirect=1`

      if(isPageReload === pageReloadOptions.WEBTOON){
        setOpenAuthorModel(false);
        localStorage.setItem('is_same_webtoon_view_page',true);
        url = `/admin/webtoon/view-webtoon/${webtoon_id}`
      }

      navigate(url, {
        state: { row: res?.data },
      });
    } catch (error) {
      toast.error(`${error.message}`);
    }
  }

  return (
    <Modal
      title="Authors Detail"
      centered
      open={openAuthorModel}
      onOk={() => setOpenAuthorModel(false)}
      onCancel={() => setOpenAuthorModel(false)}
      okButtonProps={{ className:"model-bg-color" }}
      cancelButtonProps={{ className:"model-border-color" }}  
    >
      <Card>
        <Row>
          <Col lg="12">
            <Card className="shadow m-4 detail_card">
              <CardBody className="custom-margin-top">
                <Row>
                  {authorSummaryData?.name ? (
                    <>
                      <Col lg="4"> Name</Col>
                      <Col lg="8">
                        <div className="text-dark h4">
                          {authorSummaryData.name}
                        </div>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>
                <Row className="mt-1">
                  {authorSummaryData?.original_medium ? (
                    <>
                      <Col lg="4">Original Medium</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {authorSummaryData?.original_medium}
                        </span>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>
                {authorSummaryData?.jp_name ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">JP Name</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {authorSummaryData?.jp_name}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {authorSummaryData?.jp_wikipedia ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">JP Wikipedia</Col>
                      <Col lg="8">
                        <span className="link text-dark text-wrap">
                          <a
                            href={authorSummaryData?.jp_wikipedia}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {authorSummaryData?.jp_wikipedia?.length > 50
                              ? `${authorSummaryData?.jp_wikipedia.slice(
                                  0,
                                  40
                                )}...`
                              : authorSummaryData?.jp_wikipedia}
                          </a>
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                <Row className="mt-1">
                  {authorSummaryData?.is_active ||
                  !authorSummaryData?.is_active ? (
                    <>
                      <Col lg="4">Is Active</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {authorSummaryData?.is_active ? "Yes" : "No"}
                        </span>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>

                {authorSummaryData?.created_at ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">CreatedAt</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {authorSummaryData.created_at
                            ? moment(authorSummaryData.created_at).format(
                                "YYYY-MM-DD HH:mm:ss"
                              )
                            : ""}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          {authorSummaryData?.manga ? (
            <Col lg="12">
              <Card className="me-2 shadow  m-4 view_cards">
                <CardBody>
                  <h3 className="fw-bolder dot_border">Manga</h3>
                  <Col>
                     {authorSummaryData?.manga?.map((manga) => (
                      <ul>
                        {!isLinkFunctionalityActive ? 
                         <li key={manga.manga_id}>{manga.en_title}</li> : currentMangaId === manga.manga_id ?  <li key={manga.manga_id}>{manga.en_title}</li> : <li style={{cursor: "pointer",color: "#5e72e4"}} onClick={()=>handleRedirectToViewMangaPage(manga.manga_id)} key={manga.manga_id}>{manga.en_title}</li> 
                        }
                      </ul>
                    ))}
                  </Col>
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}
          {authorSummaryData?.manga ? <Col lg="2"></Col> : ""}
          {authorSummaryData?.light_novel ? (
            <Col lg="12">
              <Card className="me-2 shadow  m-4 view_cards">
                <CardBody>
                  <h3 className="fw-bolder dot_border">Light Novel</h3>
                  <Col>
                    {authorSummaryData?.light_novel?.map((lightnovel) => (
                      <ul>
                        {!isLinkFunctionalityActive ? 
                         <li key={lightnovel.light_novel_id}>{lightnovel.en_title}</li> :  currentLightNovelId === lightnovel.light_novel_id ? <li key={lightnovel.light_novel_id}>{lightnovel.en_title}</li> : <li className="primary-text-color" style={{cursor: "pointer"}}  onClick={()=>handleRedirectToViewLightNovelPage(lightnovel.light_novel_id)}  
                         key={lightnovel.light_novel_id}>
                         {lightnovel.en_title}
                         </li> 
                        }
                      </ul>
                    ))}
                  </Col>
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}
        </Row>
        <Row>
          {authorSummaryData?.webtoon ? (
            <Col lg="12">
              <Card className="me-2 shadow  m-4 view_cards">
                <CardBody>
                  <h3 className="fw-bolder dot_border">Webtoon</h3>
                  <Col>
                    {authorSummaryData.webtoon.map((webtoon) => (
                      <ul>
                        {!isLinkFunctionalityActive ? 
                         <li key={webtoon.webtoon_id}>{webtoon.en_title}</li> : currentWebtoonId === webtoon.webtoon_id ? <li key={webtoon.webtoon_id}>{webtoon.en_title}</li> : <li className="primary-text-color" style={{cursor: "pointer"}}  onClick={()=>handleRedirectToViewWebtoonPage(webtoon.webtoon_id)} key={webtoon.webtoon_id}>{webtoon.en_title}</li> 
                        }
                      </ul>
                    ))}
                  </Col>
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </Card>
    </Modal>
  );
}
